import { useEffect } from "react";
import { getMyInfo } from "src/apis/userApi";
import SpinnerOverlay from "src/components/common/SpinnerOverlay";
import Topbar from "src/components/common/topbar/Topbar";
import useUserStore from "src/store/useUserStore";
import { useLoadingSpinnerStore } from "src/store/util/loadingSpinnerUtil";
import { validateTokensForAppStart } from "src/utils/auth/tokenValidator";
import { redirectToSignin } from "src/utils/auth/sessionErrorHandler";
import MenuContainer from "src/containers/PDA/Menu/MenuContailner";

const HomeContainer = () => {

	const { setUserInfo } = useUserStore();
	const { loadingSpinner } = useLoadingSpinnerStore();

	useEffect(() => {
		// 앱 시작 시 토큰 검증 (RefreshToken 기준)
		const tokenValidation = validateTokensForAppStart();

		// 토큰이 유효하지 않으면 조용히 로그인 페이지로 이동
		if (!tokenValidation.isValid) {
			console.log(`🔑 토큰 검증 실패: ${tokenValidation.reason} - 로그인 페이지로 이동`);
			redirectToSignin();
			return;
		}

		const initCodeList = async () => {

			const myInfo = (await getMyInfo())?.data?.data;
			setUserInfo(myInfo);
			

		}

		initCodeList();
	}, [])

	return (
		<div className="w-full min-h-screen flex flex-col bg-slate-900/5">
			<Topbar />
			<main className="flex-1 flex overflow-hidden">
				<MenuContainer />
			</main>
			{loadingSpinner && <SpinnerOverlay text="처리 중입니다..." />}
		</div>
	);
}

export default HomeContainer;